module.exports = __webpack_public_path__ + "static/media/noResultFoundImage.e14a2ebd.png";